/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import SimpleCrypto from 'simple-crypto-js';
import EmailIcon from '@material-ui/icons/Email';
import LinkIcon from '@material-ui/icons/Link';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import Add from '@material-ui/icons/Add';
import Clear from '@material-ui/icons/Clear';
import update from 'immutability-helper';
import T from 'i18n-react';
import moment from 'moment';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  createButton: {
    fontSize: '16px',
    padding: '10px 21.5px',
    color: '#2154A2',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  select: {
    width: '100%',
    background: '#C0C0C0',
    borderRadius: '2px',
  },
  dialogAction: {
    padding: '8px 20px',
  },
  copybtn: {
    backgroundColor: '#2154A2',
    color: '#FFF',
    height: '100%',
    width: '100%',
  },
  button: {
    backgroundColor: '#2154A2',
    color: '#FFF',
    padding: '10px 21.5px',
  },
  cancelButton: {
    padding: '10px 21.5px',
    color: '#003DA5',
  },
  textField: {
    backgroundColor: '#F5F5F5',
  },
  email: {
    padding: '0 10px',
  },
  link: {
    padding: '16px 0',
  },
  dialogTitle: {
    padding: '16px 24px',
  },
  dialogContent: {
    padding: '16px',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  shareWith: {
    color: '#005EFF',
  },
  svgIcon: {
    color: '#2154A2',
  },
  expiryDate: {
    padding: '10px 5px',
  },
  iconButton: {
    padding: '20px 0',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

const formDataInit = {
  shareFiles: [
    {
      receiver: '',
      expiryDate: '',
    },
  ],
};

const ShareFiles = (props) => {
  const classes = useStyles();
  const {
    id,
    companyId,
    open,
    setOpen,
    setFilesNav,
    selected,
    // setSelected,
    onShare,
    productProfileStatus,
  } = props;
  const [total, setTotal] = React.useState(0);
  const [expiryDate, setExpiryDate] = React.useState(7);
  const [mode, setMode] = React.useState('email');
  const [path, setPath] = React.useState('');
  const [formData, setFormData] = React.useState(formDataInit);
  const [message, setMessage] = React.useState('');
  const secretKey = process.env.REACT_APP_SHARE_FILE_KEY;
  const simpleCrypto = new SimpleCrypto(secretKey);
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    setPath('');
    setOpen(false);
    setFilesNav(false);
  };

  const handleExpiry = (e) => {
    setExpiryDate(e.target.value);
  };

  const handleMode = () => {
    if (mode === 'email') {
      setMode('link');
    } else {
      setMode('email');
    }
    setPath('');
  };

  const handleTotalNum = () => {
    let sum = 0;

    sum = Object.keys(selected).map((key) => {
      return selected[key].length;
    });

    setTotal(_.sum(sum));
  };

  const handleCopyToClipBoard = () => {
    const copyText = document.getElementById('pathValue');
    copyText.select();
    document.execCommand('copy');
  };

  const handleLinkGenerate = (type) => {
    const date = moment()
      .add(expiryDate, 'days')
      .calendar();
    const mergeArr = _.flatMapDeep(
      Object.keys(selected).map((key) => {
        return selected[key];
      })
    );
    const data = {
      id,
      companyId,
      date,
      files: mergeArr.map((array) => array.id),
    };

    const token = simpleCrypto.encryptObject(data);

    const link = `http://${window.location.host}/shareFiles/${token}`;

    setPath(link);

    if (type === 'email') {
      const values = {
        shareObj: formData.shareFiles,
        expiryDate,
        message,
        total: mergeArr.length,
      };
      onShare(values, link, companyId);
      setOpen(false);
    }
  };

  const handleAddReceriver = () => {
    const values = [...formData.shareFiles, {}];
    setFormData(() => ({
      shareFiles: values,
    }));
  };

  const hanldeReceiversDataChange = (value, idx, name) => {
    setFormData((prevContent) => ({
      ...prevContent,
      shareFiles: update(formData.shareFiles, {
        [idx]: { $set: { ...prevContent.shareFiles[idx], [name]: value } },
      }),
    }));
  };

  const hanldeReceiversDelete = (idx) => {
    setFormData((prevContent) => ({
      ...prevContent,
      shareFiles: update(formData.shareFiles, {
        $splice: [[idx, 1]],
      }),
    }));
  };

  useEffect(() => {
    handleTotalNum();

    // eslint-disable-next-line
  }, [selected]);

  useEffect(() => {
    if (productProfileStatus === 'sent') {
      enqueueSnackbar(T.translate('productManager.shareSuccess'), {
        variant: 'success',
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }

    // eslint-disable-next-line
  }, [productProfileStatus]);

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth='sm'
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'>
        <DialogTitle classes={{ root: classes.dialogTitle }}>
          <Grid container justify='space-between' classes={{ root: classes.capitalize }}>
            <Box fontSize='16px' fontWeight='500'>
              {T.translate('productManager.shareFiles')}
            </Box>
            <Box fontSize='16px' fontWeight='500'>
              {total} {T.translate('productManager.filesSelect')}
            </Box>
          </Grid>
        </DialogTitle>
        {mode === 'email' ? (
          <DialogContent classes={{ root: classes.dialogContent }}>
            <Grid classes={{ root: classes.email }} container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <Box fontSize='12px' fontWeight='500'>
                  {T.translate('productManager.receipient')}
                </Box>
                {formData.shareFiles.map((receiver, idx) => {
                  return (
                    <Grid container spacing={2} key={idx}>
                      <Grid item xs={6} sm={6} md={8}>
                        <TextField
                          fullWidth
                          variant='outlined'
                          value={receiver.receiver}
                          required
                          placeholder={T.translate('general.email')}
                          onChange={(e) =>
                            hanldeReceiversDataChange(e.target.value, idx, 'receiver')
                          }
                        />
                      </Grid>
                      <Grid item xs={2} sm={2} md={4}>
                        <IconButton onClick={() => hanldeReceiversDelete(idx)}>
                          <SvgIcon>
                            <Clear />
                          </SvgIcon>
                        </IconButton>
                      </Grid>
                    </Grid>
                  );
                })}
                <Grid container justify='center'>
                  <IconButton classes={{ root: classes.iconButton }} onClick={handleAddReceriver}>
                    <SvgIcon classes={{ root: classes.svgIcon }} fontSize='small'>
                      <Add />
                    </SvgIcon>
                    <Box fontSize='14px' fontWeight='500' color='#2154A2'>
                      {T.translate('productManager.addMore')}
                    </Box>
                  </IconButton>
                </Grid>
              </Grid>
              <Grid container classes={{ root: classes.expiryDate }}>
                <Grid item xs={12} sm={12} md={8}>
                  <Box fontSize='12px' fontWeight='500' classes={{ root: classes.capitalize }}>
                    {T.translate('productManager.expireOn')}
                  </Box>
                  <FormControl classes={{ root: classes.select }}>
                    <Select
                      variant='outlined'
                      value={expiryDate}
                      defaultValue={7}
                      onChange={handleExpiry}
                      renderValue={(value) => (
                        <Box fontWeight='500'>
                          {T.translate('productManager.expireOn', {
                            value,
                          })}
                        </Box>
                      )}>
                      <MenuItem value={7}>{T.translate('productManager.expireOn7Days')}</MenuItem>
                      <MenuItem value={14}>{T.translate('productManager.expireOn14Days')}</MenuItem>
                      <MenuItem value={30}>{T.translate('productManager.expireOn30Days')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Box fontSize='12px' fontWeight='500' classes={{ root: classes.capitalize }}>
                  {T.translate('productManager.messageTo')}
                </Box>
                <TextField
                  multiline
                  rows={5}
                  variant='outlined'
                  fullWidth
                  onChange={(e) => setMessage(e.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>
        ) : (
          <DialogContent>
            <Grid container classes={{ root: classes.link }} spacing={2}>
              {!path ? (
                <Grid item xs={12} sm={8} md={8}>
                  <FormControl classes={{ root: classes.select }}>
                    <Select
                      variant='outlined'
                      value={expiryDate}
                      onChange={handleExpiry}
                      renderValue={(value) => (
                        <Box fontWeight='500'>
                          {T.translate('productManager.expireOn', {
                            value,
                          })}
                        </Box>
                      )}>
                      <MenuItem value={7}>{T.translate('productManager.expireOn7Days')}</MenuItem>
                      <MenuItem value={14}>{T.translate('productManager.expireOn14Days')}</MenuItem>
                      <MenuItem value={30}>{T.translate('productManager.expireOn30Days')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={8} sm={8} md={8}>
                    <FormControl classes={{ root: classes.select }}>
                      <TextField
                        id='pathValue'
                        classes={{ root: classes.textField }}
                        variant='outlined'
                        value={path}
                        onChange={handleExpiry}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4}>
                    <Button
                      classes={{ root: classes.copybtn }}
                      variant='contained'
                      onClick={handleCopyToClipBoard}>
                      {T.translate('productManager.copyLink')}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </DialogContent>
        )}
        <DialogActions classes={{ root: classes.dialogAction }}>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6} md={6}>
              <Button
                variant='text'
                onClick={handleMode}
                startIcon={mode === 'email' ? <LinkIcon /> : <EmailIcon />}
                classes={{ root: classes.shareWith }}>
                {mode === 'email' ? (
                  <Box>{T.translate('productManager.shareWithLink')}</Box>
                ) : (
                  <Box>{T.translate('productManager.shareWithEmail')}</Box>
                )}
              </Button>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <Grid container justify='flex-end'>
                <Button
                  onClick={handleClose}
                  variant='text'
                  classes={{ root: classes.cancelButton }}>
                  {T.translate('general.cancel')}
                </Button>
                {mode === 'email' ? (
                  <Button
                    classes={{ root: classes.button }}
                    onClick={() => {
                      handleLinkGenerate('email');
                      handleClose();
                    }}
                    color='primary'
                    variant='contained'
                    // disabled={!receiver}
                    autoFocus>
                    <Box>{T.translate('productManager.share')}</Box>
                  </Button>
                ) : (
                  <Button
                    classes={{ root: classes.button }}
                    onClick={() => handleLinkGenerate('link')}
                    color='primary'
                    variant='contained'
                    autoFocus>
                    <Box>{T.translate('productManager.generateLink')}</Box>
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ShareFiles;
